import React from "react"
import PropTypes from "prop-types"

const ProfilePresenter = ({
  uid,
  subdomain,
  debitorNumber,
  companyName,
  children
}) => (
  <div
    style={{
      paddingTop: 20,
      paddingRight: 20,
      paddingBottom: 10,
      paddingLeft: 20,
      boxSizing: "border-box",
      width: "100%",
      background: "rgb(51, 51, 51)"
    }}
    class="sh-intro-section-text"
  >
    <p
      style={{
        color: "white",
        fontSize: 17,
        lineHeight: 1.8,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }}
    >
      {uid}
    </p>
    <p
      style={{color: "white", fontSize: 13, marginBottom: 20, lineHeight: 1.34}}
    >
      {companyName} ({debitorNumber})
    </p>
    <div style={{color: "white", fontSize: 15, marginBottom: 10}}>
      {children}
    </div>
  </div>
)

export default ProfilePresenter

ProfilePresenter.propTypes = {
  uid: PropTypes.string.isRequired,
  tenant: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/decorators/ProfilePresenter.js